import Icon from 'components/Icon';
import Seo from 'components/Seo';

export default function ContactPage() {
  return (
    <>
    <Seo title="Contact Us" description="Get in touch with the Devlayar team. Questions, feedback, tool requests." path="/contact" />
    <div className="static-page">
      <div className="container">
        <div className="static-hero">
          <div className="static-hero-icon"><Icon name="user" size={26} /></div>
          <h1>Contact Us</h1>
          <p>Questions, feedback, or a tool request? We're happy to hear from you.</p>
        </div>

        <div className="static-body">
          <p>The best way to reach us is by email. We read every message and try to reply as soon as we can.</p>

          <div className="contact-card">
            <div className="contact-row">
              <div className="contact-icon"><Icon name="info" size={20} /></div>
              <div>
                <div className="contact-label">Email</div>
                <a href="mailto:support@devlayar.com" className="contact-value">support@devlayar.com</a>
              </div>
            </div>
            <div className="contact-row">
              <div className="contact-icon"><Icon name="tools" size={20} /></div>
              <div>
                <div className="contact-label">Built by</div>
                <div className="contact-value">Ethoss Technologies</div>
              </div>
            </div>
          </div>

          <h2>What can you contact us about?</h2>
          <p>Reporting a tool that isn't working correctly, suggesting a new tool you'd like to see, sharing feedback about your experience, or any business or partnership enquiry. For common questions, you may also find a quick answer on our <a href="/faq">FAQ page</a>.</p>

          <h2>Response Time</h2>
          <p>We usually respond within 1–2 business days. Thanks for your patience.</p>
        </div>
      </div>
    </div>
  </>
  );
}
